import { render } from "./CreatorIncomeView.vue?vue&type=template&id=4b0c4561&scoped=true"
import script from "./CreatorIncomeView.vue?vue&type=script&lang=js"
export * from "./CreatorIncomeView.vue?vue&type=script&lang=js"

import "./CreatorIncomeView.vue?vue&type=style&index=0&id=4b0c4561&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0c4561"]])

export default __exports__